import { render, staticRenderFns } from "./VipPaymentModal.vue?vue&type=template&id=2b0e9e69&scoped=true"
import script from "./VipPaymentModal.vue?vue&type=script&lang=js"
export * from "./VipPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./VipPaymentModal.vue?vue&type=style&index=0&id=2b0e9e69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e9e69",
  null
  
)

export default component.exports